import React from "react";
import BaseEntityPage from "../base";
import WmaList from "../wma-list";

const BaseThumbnailsPage = (props) => {
    return <BaseEntityPage {...props} rootClassNames="base-thumbnails" listComponent={WmaList} />;
};

export default BaseThumbnailsPage;
